module.exports = __webpack_public_path__ + "static/v1.0.1.3/img/noData.4877c607.svg";